import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { SpinnerInfoBox } from 'rio-uikit';

const hasDropdownItems = ({ administrative, heroes, normal }) => (
    administrative.filter(Boolean).length > 0 ||
    normal.filter(Boolean).length > 0 ||
    heroes.filter(Boolean).length > 0
);

export class TabbedAppNavigator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
        };
    }

    onTabClick(event, tabIndex) {
        // FIXME: this is only a workaround, normally the clickOutside component
        // should do the right thing but it doesn't and we need to get things done
        event.preventDefault();
        event.stopPropagation();

        this.setState({
            tabIndex,
        });
    }

    renderTabs(tabIndex) {
        return (
            <ul className='nav nav-pills nav-justified'>
                <li className={tabIndex === 0 ? 'active' : ''} onClick={(event) => this.onTabClick(event, 0)}>
                    <a><FormattedMessage id='appnavigator.rioTabTitle'/></a>
                </li>
                <li className={tabIndex === 1 ? 'active' : ''} onClick={(event) => this.onTabClick(event, 1)}>
                    <a><FormattedMessage id='appnavigator.adminTabTitle'/></a>
                </li>
            </ul>
        );
    }

    renderContent(tabIndex, children) {
        //const items = groupBy(child => getOr('normal', 'props.group', child), children);
        const normalItems = children.normal;
        const heroItems = children.heroes;
        const administrativeItems = children.administrative;
        switch (tabIndex) {
            default:
            case 0:
                return (
                    <div>
                        {heroItems}
                        <div role='heading' className='dropdown-header padding-0 margin-top-10'>
                            <FormattedMessage id='appnavigator.services'/>
                        </div>
                        {normalItems}
                    </div>
                );
            case 1:
                return (
                    <div>
                        {administrativeItems}
                    </div>
                );
        }
    }

    render() {
        const { children, className } = this.props;

        if (!hasDropdownItems(children)) {
            return (
                <p className={'padding-15'}>
                    <SpinnerInfoBox text={<FormattedMessage id={'appnavigator.loading'} />} />
                </p>
            );
        }

        const tabs = this.renderTabs(this.state.tabIndex);
        const content = this.renderContent(this.state.tabIndex, children);
        return (
            <div className={`TabbedAppNavigator ${className}`}>
                {tabs}
                {content}
            </div>
        );
    }
}

export default TabbedAppNavigator;

TabbedAppNavigator.defaultProps = {
    // props
    className: '',
};

TabbedAppNavigator.propTypes = {
    // props
    className: PropTypes.string,
};
